// sessionStore.js
const KEY_TOKEN = "token";
const KEY_DATA = "data"; // the “important object” from your server

class SessionStore {
  static _token = undefined; // undefined = not loaded yet; null = loaded but empty
  static _data = undefined;
  static _em = new EventTarget();

  // --- Lazy getters ---
  static getToken() {
    if (this._token === undefined) {
      const t = localStorage.getItem(KEY_TOKEN);
      this._token = t ?? null;
    }
    return this._token; // string | null
  }

  static getData() {
    if (this._data === undefined) {
      const raw = localStorage.getItem(KEY_DATA);
      if (!raw) {
        this._data = null;
      } else {
        try { this._data = JSON.parse(raw); }
        catch { this._data = null; }
      }
    }
    return this._data; // object | null
  }

  static getChapter() {
    const data = this.getData()
    if (data.chapter) {
      return data.chapter.id
    }
    return null;
  }

  static getChapterKey(key) {
    const data = this.getData()
    if (data.chapter) {
      if (data.chapter.hasOwnProperty(key)) {
        //if organization_reltn is key this will return the obj
        return data.chapter[key]
      }
    }
  }

  static getUserKey(key) {
    const data = this.getData()
    if (data.user) {
      if (data.user.hasOwnProperty(key)) {
        return data.user[key]
      }
    }
  }

  static getUserTier() {
    const data = this.getData()
    if (data.user_tier) {
      return data.user_tier
    }
    return 1
  }

  static setToken(token) {
    if (token == null) {
      localStorage.removeItem(KEY_TOKEN);
      this._token = null;
    } else {
      localStorage.setItem(KEY_TOKEN, token);
      this._token = token;
    }
    this._em.dispatchEvent(new Event("change"));
  }

  static setData(obj) {
    if (obj == null) {
      localStorage.removeItem(KEY_DATA);
      this._data = null;
    } else {
      localStorage.setItem(KEY_DATA, JSON.stringify(obj));
      this._data = obj;
    }
    this._em.dispatchEvent(new Event("change"));
  }

  static clear() {
    this.setToken(null);
    this.setData(null);
  }

  static subscribe(cb) {
    const handler = () => cb();
    this._em.addEventListener("change", handler);

    const storageHandler = (e) => {
      if (e.key === KEY_TOKEN || e.key === KEY_DATA) {
        this._token = undefined;
        this._data = undefined;
        cb();
      }
    };

    window.addEventListener("storage", storageHandler);

    return () => {
      this._em.removeEventListener("change", handler);
      window.removeEventListener("storage", storageHandler);
    };
  }
}

export default SessionStore;

